/**
 * Messages (inbox and texting), WP1-INBOX, BUILD-PLAN M11. Replaces the
 * shell placeholder with the same module id and route.
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'inbox',
    title: 'Messages',
    version: '0.1.0',
    owner: 'WP1-INBOX',
    entitlementKey: 'texting',
    permissions: ['comms.view', 'comms.send', 'schedule.edit', 'settings.manage'],
    routes: [
      {
        id: 'threads',
        path: '/communications',
        title: 'Messages',
        permission: 'comms.view',
        officeScope: 'location-or-all',
        readsPhi: true,
      },
    ],
    nav: [
      {
        label: 'Messages',
        labelKey: 'communications',
        group: 'patients',
        routeId: 'threads',
        icon: 'message-square',
        order: 20,
        permission: 'comms.view',
      },
    ],
    commands: [
      {
        id: 'inbox.open',
        title: 'Go to Messages',
        keywords: ['inbox', 'text', 'sms', 'messages', 'conversations', 'communications'],
        routeId: 'threads',
        permission: 'comms.view',
      },
    ],
    shortcuts: [{ keys: 'g i', description: 'Go to Messages', routeId: 'threads' }],
    sseEntityKeys: ['inbox.thread'],
    phiReadPoints: ['inbox.thread'],
  }),
  pages: {
    threads: () => import('./InboxPage.js'),
  },
});
